
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1608443016892",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "5421",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M938.496 779.776L736.768 578.048c69.632-136.192 47.616-307.2-66.048-420.864-100.352-98.816-243.2-128.512-368.64-87.552-10.24 3.584-13.824 16.384-5.632 24.064L456.192 253.44c24.064 24.064 24.064 62.976 0 87.04l-117.76 117.76c-24.064 24.064-62.976 24.064-87.04 0L93.184 300.032c-7.68-7.68-20.992-4.608-24.064 6.144-38.4 123.904-8.704 264.704 89.6 363.008 113.152 113.152 282.112 135.68 417.792 67.584l200.704 200.704c41.472 41.472 108.032 46.592 153.088 9.216 51.712-42.496 54.784-120.32 8.192-166.912z m-52.224 106.496c-15.872 15.872-41.472 15.872-57.344 0s-15.872-41.472 0-57.344 41.472-15.872 57.344 0c16.384 15.872 16.384 41.472 0 57.344z",
        "p-id": "5422"
      }
    }
  ]
})
    }
  